import { Button } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Phone.css';
import { trackPhoneButtonClick } from './tracking';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { parsePhoneNumber } from '../../utils/strings';

export interface IPhoneProps {
  page: IPageState;
  total: number;
  phone?: string | null;
  entityId: number;
  favoriteEntities: IFavoriteEntity[];
  isBooked: boolean;
}

export const Phone: React.FC<IPhoneProps> = ({ page, total, phone, entityId, favoriteEntities, isBooked }) => {
  const parsedPhone = phone ? parsePhoneNumber(phone) : '';
  const [isPhoneVisible, setIsPhoneVisible] = React.useState(false);

  const handleClick = () => {
    setIsPhoneVisible(true);

    const index = favoriteEntities.findIndex(entity => entity.entityId === entityId);
    trackPhoneButtonClick({ entity: favoriteEntities[index], position: index + 1, total, deviceType: page.deviceType });
  };

  if (!parsedPhone) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {isPhoneVisible ? (
        <span className={styles['phone']} data-testid="Phone">
          {parsedPhone}
        </span>
      ) : (
        <span>
          <Button
            size="XS"
            beforeIcon={isBooked ? undefined : <IconCommunicationPhone16 color="icon-inverted-default" />}
            fullWidth={true}
            onClick={handleClick}
          >
            {isBooked ? 'Уточнить у застройщика' : 'Показать телефон'}
          </Button>
        </span>
      )}
    </div>
  );
};
